import { Component, Input, OnInit } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexStroke,
  ApexTooltip,
  ApexGrid,
  ApexXAxis,
  ApexYAxis
} from 'ng-apexcharts';

@Component({
  selector: 'app-crm-stat',
  templateUrl: './crm-stat.component.html',
  styleUrls: ['./crm-stat.component.scss']
})
export class CrmStatComponent implements OnInit {

  @Input() type: number = 1;
  @Input() title?: string;
  @Input() value: number = 0;
  @Input() icon?: string;
  @Input() profit?: 'up' | 'down';
  @Input() sign?: any;
  @Input() percentage?: string;
  @Input() iconcolor?: string;
  @Input() prefix?: any;
  @Input() suffix?: any;
  @Input() SetPic?: any;
  @Input() customClass: string = '';

  // optional external data
  @Input() chartData?: number[];

  chartSeries: ApexAxisChartSeries = [];


  ngOnInit(): void {}

   
}
